import React, { useContext } from 'react'
import Main from '../layouts/Main'
import StatisticCards from '../components/StatisticCards'
import RecentOrders from '../components/RecentOrders'
import { AuthContext } from '../contexts/AuthContext'

function Home() {
    const {profile} = useContext(AuthContext);
    return (
        <Main>

            {/* Start::page-header */}
            <div className="d-flex align-items-center justify-content-between my-4 page-header-breadcrumb flex-wrap gap-2">
                <div>
                    <p className="fw-semibold fs-20 mb-0">Welcome Back {profile.full_name || ''}</p>
                    <p className="fs-13 text-muted mb-0">Let's dive in and get things done.</p>
                </div>
            </div>
            {/* End::page-header */}
            {/* Start:: row-1 */}
            <div className="row">
                <div className="col-xxl-12">
                    <StatisticCards />
                </div>
            </div>
            {/* End:: row-1 */}
            {/* Start:: row-3 */}
            <div className="row">
                <div className="col-xxl-12">
                    <RecentOrders />
                </div>
            </div>
            {/* End:: row-3 */}


        </Main>

    )
}

export default Home